export default "__VITE_ASSET__FjXdf8RJ__"